module.exports = __webpack_public_path__ + "static/media/malaysia01.59488557.jpg";